@if (data()) {
  <div class="d-flex align-items-center h-100">
    @if (!!folder()) {
      <iris-dms-folder-grid-actions class="h-100"
                                    [showActionsMenu]="false"
                                    [folder]="folder()">
      </iris-dms-folder-grid-actions>
    } @else {
      <iris-dms-file-grid-actions class="h-100"
                                  [file]="file()">
      </iris-dms-file-grid-actions>
    }

    <sk-button appearance="icon"
               (click)="openContextMenu($event)"
               clickStopPropagation
               data-test="dms-grid-actions-template-button">
      <i class="icon far fa-ellipsis-v menu-icon"></i>
    </sk-button>
  </div>
}
